// External
import { Flex } from 'rebass';
import { func, object, array } from 'prop-types';

// Components
import IconMenu from '../../../components/IconMenu';
import IndexCatalogModal from './modals/IndexCatalogModal';
import UnIndexCatalogModal from './modals/UnIndexCatalogModal';
import AddProductsModal from './modals/AddProductsModal';
import ValidationReportModal from './modals/ValidationReportModal';
import DuplicateCatalog from './DuplicateCatalog';

import { generateValidationReport } from '../actions';
import { CATALOG_STATUS } from '../constants';

import useModal from '../../../hooks/useModal';

export const CatalogEditOptionsModalEllipsis = ({
  catalog,
  catalog: { status },
  catalogProducts,
  addProductsAction
}) => {
  const [isIndexModalOpen, openIndexModal, closeIndexModal] = useModal();
  const [isUnIndexModalOpen, openUnIndexModal, closeUnIndexModal] = useModal();
  const [isAddProductsModalOpen, openAddProductsModal, closeAddProductsModal] = useModal();
  const [isValidationReportModalOpen, openValidationReportModal, closeValidationReportModal] = useModal();
  const [isDuplicateCatalogModalOpen, openDuplicateCatalogModal, closeDuplicateCatalogModal] = useModal();

  const hasProducts = catalogProducts?.length > 0;
  const isDeleted = status === CATALOG_STATUS.DELETED;
  const isIndexed = status === CATALOG_STATUS.INDEX;

  return (
    <>
      <Flex id='ellipsisMenu' flexDirection='row' flexWrap='wrap' justifyContent='flex-end'>
        <IconMenu
          align='right'
          menuOptions={[
            ...(!isDeleted ? [{ text: 'Add Products', onClick: openAddProductsModal }] : []),
            ...(!isDeleted ? [{ text: 'Duplicate Catalog', onClick: openDuplicateCatalogModal }] : []),
            ...(!isDeleted
              ? [
                  {
                    text: isIndexed ? 'Re-Index' : 'Index',
                    onClick: openIndexModal,
                    disabled: !hasProducts
                  }
                ]
              : []),
            ...(!isDeleted && isIndexed
              ? [{ text: 'Un-Index', onClick: openUnIndexModal, disabled: !hasProducts }]
              : []),
            { text: 'Validation Report', onClick: openValidationReportModal }
          ]}
        />
      </Flex>
      <IndexCatalogModal
        closeModal={closeIndexModal}
        isOpen={isIndexModalOpen}
        catalogIds={[catalog.id]}
        catalogNames={[catalog.name]}
      />
      <UnIndexCatalogModal
        closeModal={closeUnIndexModal}
        isOpen={isUnIndexModalOpen}
        catalogIds={[catalog.id]}
        catalogNames={[catalog.name]}
      />
      <AddProductsModal
        title='Add Products to Catalog'
        closeModal={closeAddProductsModal}
        isOpen={isAddProductsModalOpen}
        addProductsAction={addProductsAction}
      />
      <ValidationReportModal
        title='Validation Report'
        closeModal={closeValidationReportModal}
        isOpen={isValidationReportModalOpen}
        generateValidationReport={generateValidationReport}
        catalogId={catalog.id}
      />
      <DuplicateCatalog
        closeDuplicateCatalogModal={closeDuplicateCatalogModal}
        isDuplicateCatalogModalOpen={isDuplicateCatalogModalOpen}
        catalogId={catalog.id}
      />
    </>
  );
};

CatalogEditOptionsModalEllipsis.propTypes = {
  catalog: object.isRequired,
  catalogProducts: array.isRequired,
  addProductsAction: func.isRequired
};

export default CatalogEditOptionsModalEllipsis;
